module.exports = __webpack_public_path__ + "static/media/not-come-red.012ee53f.svg";